import './PageHeader.css';

function PageHeader({ title, subtitle, children, center, variant = 'banner' }) {
  const hasCenter = Boolean(center);
  const hasActions = Boolean(children);
  const className = [
    'page-header',
    variant === 'banner' ? 'page-header-banner' : '',
    hasCenter ? 'page-header-has-center' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={className}>
      <div className="page-header-text">
        <h1 className="page-header-title">{title}</h1>
        {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
      </div>
      {hasCenter && <div className="page-header-center">{center}</div>}
      {hasActions ? (
        <div className="page-header-actions">{children}</div>
      ) : hasCenter ? (
        <div className="page-header-actions page-header-actions-spacer" aria-hidden="true" />
      ) : null}
    </div>
  );
}

export default PageHeader;
